<template>
  <div class="right-view">
    <AccountSelection />
  </div>
</template>
<script>
import AccountSelection from './AccountSelection.vue';

export default {
  name: 'RightView',
  components: { AccountSelection },

  methods:{

  }
};
</script>
<style>
  .right-view {
    height:100vh;
    width:50%;
  }

  @media screen and (min-width: 991px) {
    .right-view {
      overflow-y: auto;
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      scrollbar-width: none; /* Chrome, Safari & Firefox */
    }

    .right-view::-webkit-scrollbar {
      display: none;  /* Safari and Chrome */
    }
  }

  @media only screen and (max-width:990px) {
    .right-view {
      background-color: white;
      width: 100%;
      max-height: 100vh;
      height: auto;
      position: absolute;
      top: 50%;
      z-index: 2;
    }
  }

  @media only screen and (max-width: 767px) {
   .right-view {
      background-color: white;
      width: 100%;
      max-height: 100vh;
      position: absolute;
      top: 50%;
      z-index: 2;
    }
  }

  @media only screen and (max-width: 565px) {

  }

</style>
